import { ConsultationRequestUpsell } from '@models/consultation-request-upsell';

export const AcyclovirCreamHSVConsultationUpsell: ConsultationRequestUpsell = {
  id: 3069,
  price: 20,
};

export const AcyclovirCreamConsultationUpsell: ConsultationRequestUpsell = {
  id: 3018,
  price: 29,
};

export const AhTestosteronePanelConsultationUpsell: ConsultationRequestUpsell = {
  id: 3551,
  price: 99,
};

export const AhWellnessPanelConsultationUpsell: ConsultationRequestUpsell = {
  id: 3525,
  price: 49,
};

export const AtopiclairBarrierCreamConsultationUpsell: ConsultationRequestUpsell = {
  id: 3781,
  price: 20,
};

export const AzelaicAcidConsultationUpsell: ConsultationRequestUpsell = {
  id: 3636,
  price: 10,
};

export const BiotinConsultationUpsell: ConsultationRequestUpsell = {
  id: 3589,
  price: 10,
};

export const ClindamycinVaginalCreamConsultationUpsell: ConsultationRequestUpsell = {
  id: 2930,
  price: 25,
  skipOrderAddon: true,
};

export const ClotrimazoleVaginalCreamConsultationUpsell: ConsultationRequestUpsell = {
  id: 2845,
  price: 15,
};

export const ComprehensiveHealthPanelConsultationUpsell: ConsultationRequestUpsell = {
  id: 3691,
  price: 99,
};

export const DeliverMedicationConsultationUpsell: ConsultationRequestUpsell = {
  id: 2723,
  price: 39,
};

export const DoctorsNoteConsultationUpsell: ConsultationRequestUpsell = {
  id: 2721,
  price: 10,
};

export const Doxycycline1TreatmentConsultationUpsell: ConsultationRequestUpsell = {
  id: 2640,
  price: 30,
  skipOrderAddon: true,
};

export const Doxycycline15TreatmentsStdConsultationUpsell: ConsultationRequestUpsell = {
  id: 3423,
  price: 20,
  skipOrderAddon: true,
};

export const Doxycycline15TreatmentsConsultationUpsell: ConsultationRequestUpsell = {
  id: 3373,
  price: 20,
  skipOrderAddon: true,
};

export const Doxycycline30TreatmentsStdConsultationUpsell: ConsultationRequestUpsell = {
  id: 3424,
  price: 45,
  skipOrderAddon: true,
};

export const Doxycycline30TreatmentsUpsellFrom15ConsultationUpsell: ConsultationRequestUpsell = {
  id: 3382,
  price: 25,
  skipOrderAddon: true,
};

export const Doxycycline30TreatmentsConsultationUpsell: ConsultationRequestUpsell = {
  id: 3383,
  price: 45,
  skipOrderAddon: true,
};

export const DoxycyclineConsultationUpsell: ConsultationRequestUpsell = {
  id: 3664,
  price: 20,
};

export const FiberSupplementConsultationUpsell: ConsultationRequestUpsell = {
  id: 3518,
  price: 10,
};

export const FluconazoleForBVTreatmentConsultationUpsell: ConsultationRequestUpsell = {
  id: 2953,
  price: 25,
};

export const FluconazoleConsultationUpsell: ConsultationRequestUpsell = {
  id: 2719,
  price: 20,
};

export const FollowUpStdTestConsultationUpsell: ConsultationRequestUpsell = {
  id: 2967,
  price: 39,
};

export const FollowUpUrineTestConsultationUpsell: ConsultationRequestUpsell = {
  id: 2836,
  price: 29,
};

export const FreeTestosteronePanelConsultationUpsell: ConsultationRequestUpsell = {
  id: 3695,
  price: 0,
  skipAdditionalRequest: true,
};

export const Glp1BoosterConsultationUpsell: ConsultationRequestUpsell = {
  id: 3148,
  price: 49,
};

export const InjectableTrtAndHcgUpsellConsultationUpsell: ConsultationRequestUpsell = {
  id: 3682,
  price: 80,
  skipOrderAddon: true,
};

export const InjectableTrtConsultationUpsell: ConsultationRequestUpsell = {
  id: 3592,
  price: 119,
};

export const LevonorgestrelConsultationUpsell: ConsultationRequestUpsell = {
  id: 2722,
  price: 10,
};

export const LidocaineOintmentConsultationUpsell: ConsultationRequestUpsell = {
  id: 3071,
  price: 29,
};

export const MaleBVPartnerTreatmentConsultationUpsell: ConsultationRequestUpsell = {
  id: 3188,
  price: 49,
  discount: {
    name: 'Male BV Partner Treatment Discount',
    amount: 4000,
  },
};

export const MensIntimateWashConsultationUpsell: ConsultationRequestUpsell = {
  id: 2902,
  price: 29,
};

/**
 * Metformin upsell variants.
 *
 * The same {@link UpsellSlugs.Metformin} / {@link UpsellSlugs.MetforminExtendedRelease}
 * slugs map to different products (different `id` and/or `price`) depending on the
 * brand, so the variants are co-located here and each environment composes the one
 * it needs.
 */

/** Metformin IR — used by Starfish. */
export const MetforminStdConsultationUpsell: ConsultationRequestUpsell = {
  id: 3067,
  price: 25,
};

/** Metformin IR — used by Stallion and Testosterone HQ. */
export const MetforminTrtConsultationUpsell: ConsultationRequestUpsell = {
  id: 3735,
  price: 79,
  skipAdditionalRequest: true,
};

/** Metformin Extended Release — used by Starfish. */
export const MetforminExtendedReleaseStdConsultationUpsell: ConsultationRequestUpsell = {
  id: 3067,
  price: 25,
  skipOrderAddon: true,
};

/** Metformin Extended Release — used by Stallion. */
export const MetforminExtendedReleaseTrtConsultationUpsell: ConsultationRequestUpsell = {
  id: 3949,
  price: 25,
  skipOrderAddon: true,
};

export const MetronidazoleVaginalGelConsultationUpsell: ConsultationRequestUpsell = {
  id: 2931,
  price: 25,
  skipOrderAddon: true,
};

export const MetronidazoleConsultationUpsell: ConsultationRequestUpsell = {
  id: 2792,
  price: 25,
};

export const MinoxidilConsultationUpsell: ConsultationRequestUpsell = {
  id: 3772,
  price: 20,
};

/**
 * Ondansetron (Zofran) pill upsell variants.
 *
 * The same {@link UpsellSlugs.OndansetronPill} slug maps to a different product
 * (different `id` and `price`) depending on the brand, so both variants are
 * co-located here and each environment composes the one it needs.
 */

/** Used by STDcheck, Starfish, and TreatMyUTI. */
export const OndansetronPillStdConsultationUpsell: ConsultationRequestUpsell = {
  id: 2834,
  price: 20,
};

/** Used by Stallion and Testosterone HQ. */
export const OndansetronPillTrtConsultationUpsell: ConsultationRequestUpsell = {
  id: 3770,
  price: 29,
};

/** Used by STDcheck, Starfish, and TreatMyUTI. */
export const OndansetronDissolvableTabletStdConsultationUpsell: ConsultationRequestUpsell = {
  id: 2835,
  price: 20,
};

/** Used by Stallion and Testosterone HQ. */
export const OndansetronDissolvableTabletTrtConsultationUpsell: ConsultationRequestUpsell = {
  id: 3771,
  price: 29,
};

export const OralAntiInflammatorySkinMedicationConsultationUpsell: ConsultationRequestUpsell = {
  id: 3780,
  price: 20,
};

export const OralMinoxidilConsultationUpsell: ConsultationRequestUpsell = {
  id: 4013,
  price: 69,
  skipAdditionalRequest: true,
};

export const OralFinasterideConsultationUpsell: ConsultationRequestUpsell = {
  id: 4013,
  price: 69,
  skipAdditionalRequest: true,
};

export const OralTrtAndEnclomipheneUpsellConsultationUpsell: ConsultationRequestUpsell = {
  id: 3683,
  price: 80,
  skipOrderAddon: true,
};

export const OvernightShippingConsultationUpsell: ConsultationRequestUpsell = {
  id: 3159,
  price: 25,
};

export const PartnerTreatmentConsultationUpsell: ConsultationRequestUpsell = {
  id: 2982,
  price: 39,
};

export const PeptideBPC157ConsultationUpsell: ConsultationRequestUpsell = {
  id: 3733,
  price: 139,
  skipAdditionalRequest: true,
};

export const PeptideCJC1295IpamorelinConsultationUpsell: ConsultationRequestUpsell = {
  id: 3733,
  price: 139,
  skipAdditionalRequest: true,
};

export const PeptideGHKCuConsultationUpsell: ConsultationRequestUpsell = {
  id: 3733,
  price: 139,
  skipAdditionalRequest: true,
};

export const PriorityProcessingConsultationUpsell: ConsultationRequestUpsell = {
  id: 3628,
  price: 10,
  skipAdditionalRequest: true,
};

export const ProbioticsConsultationUpsell: ConsultationRequestUpsell = {
  id: 2720,
  price: 10,
};

export const PyridiumConsultationUpsell: ConsultationRequestUpsell = {
  id: 2718,
  price: 20,
};

export const RectalCreamAndSuppositoryConsultationUpsell: ConsultationRequestUpsell = {
  id: 3522,
  price: 20,
  skipOrderAddon: true,
};

export const SemaglutideInjectable0_5mgConsultationUpsell: ConsultationRequestUpsell = {
  id: 3164,
  price: 65,
  skipOrderAddon: true,
};

export const SemaglutideInjectable1_7mgConsultationUpsell: ConsultationRequestUpsell = {
  id: 3166,
  price: 65,
  skipOrderAddon: true,
};

export const SemaglutideInjectable1mgConsultationUpsell: ConsultationRequestUpsell = {
  id: 3165,
  price: 65,
  skipOrderAddon: true,
};

export const SemaglutideInjectable2_5mgConsultationUpsell: ConsultationRequestUpsell = {
  id: 3168,
  price: 65,
  skipOrderAddon: true,
};

export const SemaglutideOral12mgConsultationUpsell: ConsultationRequestUpsell = {
  id: 3707,
  price: 65,
  skipOrderAddon: true,
};

export const SemaglutideOral5mgConsultationUpsell: ConsultationRequestUpsell = {
  id: 3706,
  price: 65,
  skipOrderAddon: true,
};

export const ShippedProbioticsConsultationUpsell: ConsultationRequestUpsell = {
  id: 2991,
  price: 10,
};

export const SildenafilConsultationUpsell: ConsultationRequestUpsell = {
  id: 3734,
  price: 69,
  skipAdditionalRequest: true,
};

export const Spf50SunscreenConsultationUpsell: ConsultationRequestUpsell = {
  id: 3645,
  price: 10,
};

export const Std10TestPanelConsultationUpsell: ConsultationRequestUpsell = {
  id: 3187,
  price: 139,
};

export const StoolSoftenerConsultationUpsell: ConsultationRequestUpsell = {
  id: 3526,
  price: 10,
};

export const TadalafilConsultationUpsell: ConsultationRequestUpsell = {
  id: 3734,
  price: 69,
  skipAdditionalRequest: true,
};

export const TirzepatideInjectable10mgConsultationUpsell: ConsultationRequestUpsell = {
  id: 3171,
  price: 89,
  skipOrderAddon: true,
};

export const TirzepatideInjectable12_5mgConsultationUpsell: ConsultationRequestUpsell = {
  id: 3172,
  price: 89,
  skipOrderAddon: true,
};

export const TirzepatideInjectable15mgConsultationUpsell: ConsultationRequestUpsell = {
  id: 3173,
  price: 89,
  skipOrderAddon: true,
};

export const TirzepatideInjectable5mgConsultationUpsell: ConsultationRequestUpsell = {
  id: 3169,
  price: 89,
  skipOrderAddon: true,
};

export const TirzepatideInjectable7_5mgConsultationUpsell: ConsultationRequestUpsell = {
  id: 3170,
  price: 89,
  skipOrderAddon: true,
};

export const TirzepatideOral4mgConsultationUpsell: ConsultationRequestUpsell = {
  id: 3709,
  price: 89,
  skipOrderAddon: true,
};

export const TirzepatideOral5mgConsultationUpsell: ConsultationRequestUpsell = {
  id: 3710,
  price: 89,
  skipOrderAddon: true,
};

export const TopicalMinoxidilConsultationUpsell: ConsultationRequestUpsell = {
  id: 3596,
  price: 87,
};

export const TrtAndEnclomipheneConsultationUpsell: ConsultationRequestUpsell = {
  id: 3550,
  price: 199,
};

export const TrtAndHcgConsultationUpsell: ConsultationRequestUpsell = {
  id: 3549,
  price: 199,
};

export const TrtGelAndEnclomipheneUpsellConsultationUpsell: ConsultationRequestUpsell = {
  id: 3684,
  price: 80,
  skipOrderAddon: true,
};

export const VasculeraConsultationUpsell: ConsultationRequestUpsell = {
  id: 3523,
  price: 20,
};

export const VitaminB12SupplementConsultationUpsell: ConsultationRequestUpsell = {
  id: 3101,
  price: 10,
};

export const VitaminDSupplementConsultationUpsell: ConsultationRequestUpsell = {
  id: 3066,
  price: 10,
};

export const ZincSupplementConsultationUpsell: ConsultationRequestUpsell = {
  id: 3637,
  price: 10,
};

export const ZofranTreatmentDissolvableTabletConsultationUpsell: ConsultationRequestUpsell = {
  id: 3233,
  price: 10,
  skipOrderAddon: true,
};
